import { useSearchParams } from 'react-router-dom';

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParam = (key: string): string | null => searchParams.get(key);

  const getAllParams = (): Record<string, string> => {
    const result: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  };

  const setParams = (params: Record<string, string | number | null | undefined>) => {
    const newParams = new URLSearchParams(searchParams);
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        newParams.delete(key);
      } else {
        newParams.set(key, String(value));
      }
    });
    setSearchParams(newParams);
  };

  const deleteParam = (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete(key);
    setSearchParams(newParams);
  };

  const deleteParams = (keys: string[]) => {
    const newParams = new URLSearchParams(searchParams);
    keys.forEach((key) => newParams.delete(key));
    setSearchParams(newParams);
  };

  return {
    getParam,
    setParams,
    deleteParam,
    deleteParams,
    getAllParams,
  };
};
